<template>
  <div>
    <!-- 库位管理 -->
    <baseBreadcrumb :page="$t('message.storageLocationManagement')" :menu="$t('message.warehouse')"></baseBreadcrumb>
    <div class="body">
      <!-- 筛选和批量操作与表头一起吸顶，滚动时保持可见 -->
      <div class="head" ref="stickyToolbar">
        <div class="search">
          <!--  货架编号-->
          <div class="input">
            <el-input :placeholder="$t('message.shelfNumber')" v-model="datas.shelf_number" clearable
              onfocus="this.select()"></el-input>
          </div>
         
          <div class="input">
            <!-- 范围与使用人员独立选择，均使用当前账号权限层级下的数据。 -->
            <el-cascader v-model="datas.org_id" :options="adminOrganization" :props="{
              expandTrigger: 'hover',
              label: 'name',
              value: 'id',
              children: 'childs',
              checkStrictly: true,
              emitPath: false,
            }" :placeholder="$t('message.scopeOfPersonnel')" filterable clearable @change="onOrgChange" />
          </div>
          <div class="input">
            <!-- 使用人员 -->
            <el-select v-model="datas.admin_id" :placeholder="$t('message.shelfUserPersonnel')" filterable clearable
              @change="onAdminChange">
              <el-option v-for="item in dataUserList" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="input">
            <!--  货架类别-->
            <el-select v-model="datas.shelf_type" :placeholder="$t('message.categoryOfShelves')" filterable clearable>
              <el-option v-for="item in typeOptions" :key="item.id" :label="item.type" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">
            {{ $t("message.search") }}
          </el-button>
        </div>
        <div class="btn">
          <!-- 批量打印 -->
          <el-button type="primary" @click="openBatchPrint">
            {{ $t("message.batchPrint") }}
          </el-button>
          <!-- 批量设置库位数量 -->
          <el-button type="primary" @click="setStorageLocation(multipleSelection)" v-if="isAuth(762)">
            批量设置库位数量
          </el-button>
          <!-- 打印库位唛头 -->
          <el-button type="primary" @click="printStorageLocationLabels">
            {{ $t("message.printStorageLocationLabels") }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="80" align="center"></el-table-column>
          <el-table-column align="center" label="NO" width="80" prop="rowNumber">
          </el-table-column>
          <!-- 货架编号 -->
          <el-table-column align="center" :label="$t('message.shelfNumber')" >
            <template slot-scope="scope">
              <span>{{ scope.row.area_type_code }}-{{ scope.row.shelf_number }}</span>
            </template>
          </el-table-column>
         
          <!-- 货架类别 -->
          <el-table-column align="center" :label="$t('message.categoryOfShelves')" prop="shelf_type_name">
          </el-table-column>
          <!-- 货架备注 -->
          <el-table-column align="center" :label="$t('message.remarksOnShelves')" prop="shelf_remark">
          </el-table-column>
          <!-- 使用范围 -->
          <el-table-column align="center" :label="$t('message.scopeOfUse')">
            <template slot-scope="scope">
             {{ scope.row.range_type_name }}
            </template>
          </el-table-column>
          <!-- 层数 -->
          <el-table-column align="center" :label="$t('message.numberOfLayers')" prop="floor">
          </el-table-column>
          <!-- 该层库位数 -->
          <el-table-column align="center" :label="$t('message.numberOfStorageLocationsInLayer')" prop="grid_count">
          </el-table-column>
          <!-- 打印库位唛头 -->
          <el-table-column align="center" :label="$t('message.printStorageLocationLabels')">
            <template slot-scope="scope">
              <el-button type="text" @click="gridMarks(false, scope.row.floor_number, 'default')">原唛头</el-button>
              <el-button type="text" @click="gridMarks(false, scope.row.floor_number, 'a4')">A4唛头</el-button>
              <el-button type="text" @click="gridMarks(false, scope.row.floor_number, '100x40')">10×4唛头</el-button>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" width="180px">
            <template slot-scope="scope">
              <!-- 设置库位 -->
              <p style="margin-bottom: 10px" v-if="isAuth(763)">
                <el-button type="primary" class="primary" size="small"
                  @click="openGridAttributeSetting(scope.row)" >设置库位</el-button>
              </p>
              <!-- 设置库位数量 -->
              <p style="margin-bottom: 10px" v-if="isAuth(762)">
                <el-button type="primary" class="primary" size="small"
                  @click="setStorageLocation([scope.row], scope.row.grid_count)">设置库位数量</el-button>
              </p>
              <!-- 删除 -->
              <el-button type="success" class="dark" size="small" @click="wmsGridBatchDelete(scope.row)" v-if="isAuth(764)" >{{
                $t("message.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[100, 200, 500, 1000]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 设置库位数量 -->
    <el-dialog title="设置库位数量" :visible.sync="wmsGridSetDialogVisible" width="450px" center>
      <div class="row">
        <div class="label">库位数量:</div>
        <el-input v-model="wmsGrid.num" type="number"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wmsGridSet">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
    <gridAttributeSetting ref="gridAttributeSetting" @saved="gridList" />
    <!-- 批量打印选项 -->
    <el-dialog :title="$t('message.batchPrint')" :visible.sync="batchPrintDialogVisible" width="450px" center
      :close-on-click-modal="false">
      <div class="printOptions">
        <div class="row">
          <div class="label">打印版式:</div>
          <div class="val">
            <el-radio v-model="gridMarksLayout" label="default">原唛头</el-radio>
            <el-radio v-model="gridMarksLayout" label="a4">A4唛头</el-radio>
            <el-radio v-model="gridMarksLayout" label="100x40">10×4唛头</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchPrintDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="batchPrinting" @click="batchPrint">打印</el-button>
      </span>
    </el-dialog>
    <!-- 打印选项 -->
    <el-dialog :title="$t('message.printOptions')" :visible.sync="printOptionsDialogVisible" width="450px" center
      :close-on-click-modal="false">
      <div class="printOptions">
        <div class="row">
          <div class="label">打印版式:</div>
          <div class="val">
            <el-radio v-model="gridMarksLayout" label="default">原唛头</el-radio>
            <el-radio v-model="gridMarksLayout" label="a4">A4唛头</el-radio>
            <el-radio v-model="gridMarksLayout" label="100x40">10×4唛头</el-radio>
          </div>
        </div>
        <div class="row">
          <div class="label">模式:</div>
          <div class="val">
            <el-radio v-model="gridMarksType" label="1">按范围打印</el-radio>
            <el-radio v-model="gridMarksType" label="2">具体库位打印</el-radio>
          </div>
        </div>
        <div class="row" v-if="gridMarksType == 1">
          <div class="label">选择打印范围:</div>
          <div class="val">
            <cascader :org_id="gridMarksData.org_id" @setUserList="getgridMarksData" />
          </div>
        </div>
        <div class="row" v-if="gridMarksType == 2">
          <div class="label">库位编号：:</div>
          <div class="val">
            <el-input v-model="gridMarksData.grid_number"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 生成唛头 -->
        <el-button type="primary" @click="gridMarks(true)">生成唛头</el-button>
      </span>
    </el-dialog>
    <warehouseLabel ref="warehouseLabel" v-if="printData != false && gridMarksLayout == 'default'" :printData="printData" />
    <warehouseLabelA4 ref="warehouseLabelA4" v-if="printData != false && gridMarksLayout == 'a4'" :printData="printData" />
    <warehouseLabel100x40 ref="warehouseLabel100x40" v-if="printData != false && gridMarksLayout == '100x40'"
      :printData="printData" />
  </div>
</template>
<script>
import warehouseLabel from '@/components/Printedsheet/warehouseLabel'
import warehouseLabelA4 from '@/components/Printedsheet/warehouseLabelA4'
import warehouseLabel100x40 from '@/components/Printedsheet/warehouseLabel100x40'
import gridAttributeSetting from './components/gridAttributeSetting'
export default {
  components: {
    warehouseLabel,
    warehouseLabelA4,
    warehouseLabel100x40,
    gridAttributeSetting
  },
  data() {
    return {
      typeOptions: [],//货架类别
      datas: {
        page: 1,
        pageSize: 100,
        area_number: "",
        shelf_number: "",
        shelf_type: "",
        range: "",
        org_id: "",
        admin_id: "",
      },
      adminOrganization: [],
      dataUserList: [],
      total: 0,
      tableData: [],
      multipleSelection: [],
      wmsGridSetDialogVisible: false,
      wmsGrid: {
        num: ''
      },
      printOptionsDialogVisible: false,
      batchPrintDialogVisible: false,
      batchPrinting: false,
      gridMarksType: '1',
      gridMarksLayout: 'default',
      // 库位唛头查询
      gridMarksData: {
        admin_id: '',
        org_id: '',
        grid_number: '',
      },
      printData: [],


    };
  },
  computed: {},
  created() {
    this.loadUserOptions()
    this.gridList();

    this.$api.warehouseApi.shelfTypes(this.datas).then((res) => {
      this.typeOptions = res.data;
    });

  },
  mounted() {
    // 筛选按钮换行或窗口尺寸变化时，表头始终紧贴筛选区下方。
    const toolbar = this.$refs.stickyToolbar
    this.stickyToolbarObserver = new ResizeObserver(() => {
      toolbar.parentElement.style.setProperty('--storage-sticky-toolbar-height', `${toolbar.offsetHeight}px`)
    })
    this.stickyToolbarObserver.observe(toolbar)
  },
  beforeDestroy() {
    this.stickyToolbarObserver.disconnect()
  },
  methods: {

    gridList() {
      this.$api.warehouseApi.gridList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.is_show = item.is_show == 1 ? true : false;
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.gridList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.gridList();
    },
    handleSizeChange(val) {
      this.datas.page = 1
      this.datas.pageSize = val;
      this.gridList();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    // 批量设置库位
    setStorageLocation(list, num) {
      this.wmsGrid.list = []
      this.wmsGrid.num = num ? num : ''
      if (list == false) return this.$message.error('请选择要操作的列表')
      list.forEach(item => {
        this.wmsGrid.list.push({
          shelf_number: item.shelf_number,
          floor: item.floor
        })
      })
      this.wmsGridSetDialogVisible = true;
    },
    // 打开库位属性设置
    openGridAttributeSetting(row) {
      this.$refs.gridAttributeSetting.open(row)
    },
    // 设置库位
    wmsGridSet() {
      this.$api.warehouseApi.wmsGridSet(this.wmsGrid).then((res) => {
        this.wmsGridSetDialogVisible = false
        this.$message.success(res.msg);
        this.gridList();
      });
    },  // 删除货架
    wmsGridBatchDelete(item) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            list: [
              {
                shelf_number: item.shelf_number,
                floor: item.floor
              }
            ]
          }
          this.$api.warehouseApi.wmsGridBatchDelete(datas).then((res) => {
            this.$message.success(res.msg);
            this.gridList();
          });
        })
        .catch(() => { });
    },
    // 与设置货架使用人使用相同数据源，人员选项不随筛选范围联动。
    loadUserOptions() {
      this.$api.roleApi.getAdminOrganization().then((res) => {
        this.adminOrganization = res.data || []
      })
      this.$api.getAuthWorkGroupAdminDepart({ format_list: 1 }).then((res) => {
        this.dataUserList = res.data || []
      })
    },
    // 两个条件二选一，清空时统一使用空字符串提交。
    onOrgChange(value) {
      this.datas.org_id = value || ''
      if (value) this.datas.admin_id = ''
    },
    onAdminChange(value) {
      if (value) this.datas.org_id = ''
    },
    getgridMarksData(data) {
      this.gridMarksData.org_id = data.id;
    },
    // 勾选库位层后选择版式进行批量打印
    openBatchPrint() {
      if (!this.multipleSelection.length) return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"))
      this.gridMarksLayout = 'default'
      this.batchPrintDialogVisible = true
    },
    // 每个已勾选库位层分别请求唛头数据，合并后一次打印
    async batchPrint() {
      if (!this.multipleSelection.length) return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"))
      this.batchPrinting = true
      try {
        const printData = []
        for (const item of this.multipleSelection) {
          const res = await this.$api.warehouseApi.gridMarks({ floor_number: item.floor_number })
          if (res.data != false) {
            res.data.forEach((label, index) => {
              printData.push({ ...label, print_index: index + 1 })
            })
          }
        }
        if (!printData.length) return this.$message.error('没有数据，请重新选择打印库位唛头')
        this.printData = printData
        this.batchPrintDialogVisible = false
        this.$nextTick(() => {
          const labelRef = this.getGridMarksLabelRef()
          this.$print(this.$refs[labelRef])
          this.printData = []
        })
      } finally {
        this.batchPrinting = false
      }
    },
    //打印库位唛头
    printStorageLocationLabels() {
      this.gridMarksData = {
      }
      this.gridMarksType = '1'
      this.gridMarksLayout = 'default'
      this.printOptionsDialogVisible = true
    },
    // 生成唛头
    gridMarks(type, floor_number, layout) {
      let datas = {}
      if (type) {
        datas.grid_number = this.gridMarksData.grid_number
        datas.org_id = this.gridMarksData.org_id
      } else {
        this.gridMarksLayout = layout
        datas.floor_number = floor_number
      }
      this.$api.warehouseApi.gridMarks(datas).then((res) => {
        if (res.data == false) return this.$message.error('没有数据，请重新选择打印库位唛头')
        this.printData = res.data
        this.printOptionsDialogVisible = false
        this.$nextTick(() => {
          const labelRef = this.getGridMarksLabelRef()
          this.$print(this.$refs[labelRef]);
          this.printData = []
        });
      });
    },
    // 根据选择的版式返回对应打印组件。
    getGridMarksLabelRef() {
      if (this.gridMarksLayout == 'a4') return 'warehouseLabelA4'
      if (this.gridMarksLayout == '100x40') return 'warehouseLabel100x40'
      return 'warehouseLabel'
    },
  },
};
</script>
<style lang='scss' scoped>
.body {
  --storage-sticky-toolbar-height: 78px;
}

.head {
  position: sticky;
  top: 0;
  z-index: 30;
  padding: 14px 0 24px;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;

  .search {
    display: flex;

    .input {
      width: 200px;
      margin-right: 24px;

      .el-select,
      .el-cascader {
        width: 100%;
      }
    }
  }
}

.table {
  overflow: visible;

  // 释放 Element Table 外层的 overflow，让表头跟随 el-main 滚动容器吸顶。
  /deep/ .el-table {
    overflow: visible;
  }

  /deep/ .el-table__header-wrapper {
    position: sticky;
    top: var(--storage-sticky-toolbar-height);
    z-index: 29;
    background: #edeff4;
  }
}

.content {
  padding: 0 15px;

  /deep/.el-textarea__inner {
    height: 120px;
  }

  .el-select {
    width: 100%;
  }
}

.el-icon-printer {
  font-size: 40px;
  cursor: pointer;
}

.row {
  line-height: 40px;
  display: flex;
  margin: 0 20px;

  .label {
    margin-right: 10px;
    width: 100px;
  }
}

.printOptions {
  .row {
    margin-bottom: 20px;
  }

  .label {
    width: 100px;
    text-align: right;
  }

  .val {
    flex: 1;
  }
}
</style>
